import { render, staticRenderFns } from "./MarginControl.vue?vue&type=template&id=26ea0a93&"
import script from "./MarginControl.vue?vue&type=script&lang=js&"
export * from "./MarginControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports